import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Message, Radio } from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { ALL_USER_INSTITUTION_CELLS, USER_INSTITUTION_CELL } from '../constants/UserInstitutionsConstants';

import { DIALOG_NAMES } from '../managers/DialogManager';
import { VIEW_SELECTION } from '../managers/NavigationManager';

import '../css/Profile.less';

import { getEnvironmentSpecificTranslationKey } from '../utils/environmentHelper';

export default @inject(
  'classroomManager', 'dialogManager', 'navigationManager', 'userManager')
@observer
class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false, // eslint-disable-line react/no-unused-state
      firstName: '',
      lastName: '',
      saved: false,
      textHelpEnabled: false,
       // Store profile page items for tab order management// Store main view items for tab order management
    };
    this.Avatar = SatCoreComponent('Avatar');
    this.FullScreenModalPage = SatCoreComponent('FullScreenModalPage');
    this.UserInstitutions = SatCoreComponent('UserInstitutions');
    this.mainView = [];
    this.profileItems = [];
  }

  componentDidMount() {
    const { userManager, navigationManager } = this.props;
    navigationManager.setView(VIEW_SELECTION.PROFILE);
    this.setState({ firstName: userManager.firstName, lastName: userManager.lastName, textHelpEnabled: userManager.textHelpEnabled });
    this.fetchUserOptions();
    this.initializeProfileItems();
    this.initializeMainContentItems();
    // Hide main-content elements
    const mainContent = !document.body.classList.contains('empower');
    if (mainContent) {
      this.removeMainViewFromTabOrder();
    }
  }

  componentWillUnmount() {
    this.restoreMainViewToTabOrder();
    this.restoreProfileItemsToTabOrder();
  }

  initializeProfileItems = () => {
    // Get all focusable elements in the profile page
    this.profileItems = Array.from(document.querySelectorAll('.profile-container button, .profile-container input, .profile-container a'));
  };

  initializeMainContentItems = () => {
    // Get all focusable elements in the profile page
     this.mainView.push(document.getElementById('root'));
  };

  removeProfileItemsFromTabOrder = () => {
    this.profileItems.forEach(item => {
      item.tabIndex = -1;
      item.ariaHidden = 'true';
    });
   
  };

  removeMainViewFromTabOrder = () => {
    this.mainView.forEach(item => {
      item.classList.add('hide-me');
    });
  };

  restoreProfileItemsToTabOrder = () => {
    this.profileItems.forEach(item => {
      item.tabIndex = -1;
      item.ariaHidden = 'true';
    });
    
  };

  restoreMainViewToTabOrder = () => {
    this.mainView.forEach(item => {
      item.classList.remove('hide-me');
    });
  };

  onClose = () => {
    const { dialogManager, history: { push, location: { state: { url } = { url: '/' } } } } = this.props;
    // // ensure AddUserInstitutionModal is closed upon closing Profile modal
    // if (dialogManager.openedDialogs.has(DIALOG_NAMES.ADD_USER_INSTITUTION_MODAL)) {
    //   dialogManager.closeDialog(DIALOG_NAMES.ADD_USER_INSTITUTION_MODAL);
    // }
    // Show main-content elements before closing
    const mainContent = !document.body.classList.contains('empower');
    if (mainContent) {
      this.restoreProfileItemsToTabOrder();
      this.restoreMainViewToTabOrder();
    }
    push(url);
  };

  verifyChanges = async () => {
    const { classroomManager, userManager } = this.props;
    const { firstName, lastName } = this.state;
    // eslint-disable-next-line sort-keys, react/no-unused-state
    this.setState({ saved: false, error: false });

    let changesHappened = false;

    if (firstName && firstName !== userManager.firstName) {
      changesHappened = true;
    }
    if (lastName && lastName !== userManager.lastName) {
      changesHappened = true;
    }

    if (changesHappened) {
      const result = await userManager.saveChanges({ firstName, lastName });

      if (result) {
        const { isTeacher } = userManager;
        const { currentClassroomId } = classroomManager;

        if (isTeacher && currentClassroomId && classroomManager.getClassroom(currentClassroomId)) {
          // user is a teacher with a cached classroom and profile changes have happened.
          // each classroom object is associated with certain aspects of a teacher's user profile, e.g. name.
          // ---
          // since the teacher's profile information has now changed,
          // any cached classroom where the logged in user is 'lead teacher' is now likely outdated
          // ---
          // refetch the teacher's classroom data to ensure it is up-to-date.
          await classroomManager.fetchClassroomData(classroomManager.currentClassroomId);

          // eslint-disable-next-line sort-keys, react/no-unused-state
          this.setState({ saved: true, error: false });
        } else {
          // eslint-disable-next-line sort-keys, react/no-unused-state
          this.setState({ saved: true, error: false });
        }
      } else {
        // eslint-disable-next-line sort-keys, react/no-unused-state
        this.setState({ saved: false, error: true });
      }
    }
  };

  handleChangeFirstName = (e, data) => {
    this.setState({ firstName: data.value });
  };

  handleChangeLastName = (e, data) => {
    this.setState({ lastName: data.value });
  };

  fetchUserOptions = async () => {
    const { userManager } = this.props;
    await userManager.fetchMyUserOptions();
    this.setState({ textHelpEnabled: userManager.textHelpEnabled });
  };

  toggleAvatarEditor = () => {
    const { dialogManager } = this.props;

    if (dialogManager.openedDialogs.has(DIALOG_NAMES.AVATAR)) {
      // dialogManager.closeDialog(DIALOG_NAMES.AVATAR);
      window.location.reload();
      setTimeout(() => {
        if (dialogManager.openedDialogs.has(DIALOG_NAMES.AVATAR)) {
          dialogManager.closeDialog(DIALOG_NAMES.AVATAR);
        }
      }, 300);
    } else {
      this.verifyChanges(); // save any profile changes prior to launching the avatar editor
      dialogManager.setOpenDialog(DIALOG_NAMES.AVATAR, {}, this.toggleAvatarEditor);
    
    }
  };

  handleTextHelp = async () => {
    const { userManager } = this.props;
    const { textHelpEnabled } = this.state;
    const toggle = !textHelpEnabled;
    const success = await userManager.updateMyTextHelpOption(toggle);
    if (success) {
      this.fetchUserOptions();
    }
  };

  navToChangePassword = () => {
    const { changePasswordModal, dialogManager, history, t, userManager } = this.props;

    const { username, isTeacher } = userManager;
    const externalChangePasswordUrlKey = getEnvironmentSpecificTranslationKey('externalChangePasswordUrl');
    const externalChangePasswordUrl = t(externalChangePasswordUrlKey, { email: username });
    if (externalChangePasswordUrl && isTeacher) {
      window.open(externalChangePasswordUrl, '_blank');
      return;
    }
    if (!changePasswordModal) {
      return history.push('/change-password');
    }
    this.removeProfileItemsFromTabOrder();
    dialogManager.setOpenDialog(DIALOG_NAMES.CHANGE_PASSWORD, {}, () => {
      this.restoreProfileItemsToTabOrder();
      dialogManager.closeDialog(DIALOG_NAMES.CHANGE_PASSWORD);
    });
  };

  renderErrors() {
    const { saved, fail } = this.state;
    return (
      <>
        {saved && (
        <Message positive>
          <Message.Header>Success</Message.Header>
          <p>
            Your profile has been updated.
          </p>
        </Message>
        )}
        {fail && (
        <Message negative>
          <Message.Header>Something went wrong</Message.Header>
          <p>
            Your profile failed to save please try again.
          </p>
        </Message>
        )}
      </>
    );
  }

  renderContent() {
    const { Avatar, UserInstitutions } = this;
    const { userManager, t } = this.props;
    const { firstName, lastName, textHelpEnabled } = this.state;
    const {
      isAlwaysReadOnlyUserInstitutionsListFromProfile,
      isTeacher,
      isUserProfileReadOnly
    } = userManager;
    const readOnly = isTeacher && isUserProfileReadOnly;

    // TODO per DEMO-3081, we are limiting the UserInstitutions list satellite scope to schools-only for now.
    // TODO also per DEMO-3081, completely hide this feature from students for now
    const hideUserInstitutionsListFromProfile = userManager.hideUserInstitutionsListFromProfile || (
      userManager.isDistrictAdmin || userManager.isStudent
    );

    const allowedUserInstitutionCells = ALL_USER_INSTITUTION_CELLS.filter((cellName) => {
      switch (cellName) {
        case USER_INSTITUTION_CELL.INSTITUTION:
          return true;
        case USER_INSTITUTION_CELL.PARENT_DISTRICT:
          // TODO suppressed per DEMO-3081 limited scope
          return false;
          // return userManager.isDistrictAdmin;
        case USER_INSTITUTION_CELL.COUNTRY:
          // TODO suppressed per DEMO-3081 limited scope
          return false;
          // return userManager.isDistrictAdmin;
        case USER_INSTITUTION_CELL.REMOVE:
          if (isAlwaysReadOnlyUserInstitutionsListFromProfile) {
            return false;
          }
          return !userManager.isStudent && !userManager.isSsoUser && !readOnly;
        default:
          return userManager.isDistrictAdmin;
      }
    });

    const userInstitutionsReadOnly = (
      isAlwaysReadOnlyUserInstitutionsListFromProfile || readOnly || userManager.isStudent || userManager.isSsoUser
    );
    const userInstitutionsSearchType = 'school';
    // const userInstitutionsSearchType = userManager.isDistrictAdmin ? 'institution' : 'school';

    return (
      <div className='profile-container'>
        <div className='profile-header'>
          <h2 tabIndex='0' className='profile-txt'>{t('header')}</h2>
          <div className='avatar-controls'>
            <Avatar className='profile-avatar' fullProfileImageUrl={userManager.fullProfileImageUrl} />
            <Button className='avatar-button' onClick={this.toggleAvatarEditor} size='mini'>{t('editAvatarButton')}</Button>
          </div>
        </div>
        <div className='profile-fields'>
          <div className='profile-field-txt'>{t('firstName', 'First Name')}</div>
          <Input
            disabled={userManager.isSsoUser || userManager.isStudent || readOnly}
            name='firstName'
            onChange={this.handleChangeFirstName}
            placeholder={t('firstName')}
            type='text'
            value={firstName} />
          <div className='profile-field-txt'>{t('lastName', 'Last Name')}</div>
          <Input
            disabled={userManager.isSsoUser || userManager.isStudent || readOnly}
            name='lastName'
            onChange={this.handleChangeLastName}
            placeholder={t('lastName')}
            type='text'
            value={lastName} />
          <div className='profile-field-txt'>{t('username', 'Username/email')}</div>
          <Input
            disabled={true}
            placeholder={t('username')}
            type='text'
            value={userManager.username} />

          {/*
            TextHelp user opt-in toggle — previously gated TextHelp in the legacy html-publisher
            lesson player via thEnabled (not DocReader). No longer used; React player does not
            consult this preference for TextHelp visibility.
          {(userManager.publisherTextHelpActive && !userManager.showTextHelpForAll && !readOnly) ? (
            <>
              <div className='profile-field-txt' />
              <Radio
                checked={textHelpEnabled}
                disabled={false}
                label={t('enableTextHelp')}
                onChange={() => { this.handleTextHelp(); }}
                toggle />
            </>
          ) : ''}
          */}

          {!hideUserInstitutionsListFromProfile && (
            <UserInstitutions
              allowedCells={allowedUserInstitutionCells}
              onChange={async ({ primaryInstitutionChanged } = {}) => {
                if (primaryInstitutionChanged) {
                  await userManager.checkUser();
                }
              }}
              primaryInstitutionId={userManager.institutionId}
              readOnly={userInstitutionsReadOnly}
              searchType={userInstitutionsSearchType}
              userId={userManager.userId} />
          )}
        </div>
        {!userManager.isSsoUser && (
          <Button basic className='profile-change-password-btn' onClick={this.navToChangePassword} primary>
            {t('changePasswordButton')}
          </Button>
        )}
        {!readOnly && (
          <Button className='profile-save-changes-btn' onClick={this.verifyChanges} primary>
            {t('saveButton')}
          </Button>
        )}
        {this.renderErrors()}
      </div>
    );
  }

  render() {
    const { FullScreenModalPage, props: { fullScreenModal } } = this;
    const { t } = this.props;
    if (!fullScreenModal) {
      return (
        <div className='profile-page'>
          {this.renderContent()}
        </div>
      );
    }
    const profileModalTitle = t('profileModalTitle');
    return (
      <FullScreenModalPage
        aria-label={t('ariaProfileView')}
        className='profile-page'
        close={this.onClose}
        tabIndex={-1}
        title={profileModalTitle}>
        {this.renderContent()}
      </FullScreenModalPage>
    );
  }
}

Profile.defaultProps = {
  changePasswordModal: true,
  fullScreenModal: true
};

SatCoreRegister('Profile', Profile);
